import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import { Redirect } from "react-router-dom";

import { CustomCard } from "../../components/Card/CustomCard";
import HeaderHome from "../HeaderHome"

import { Url } from '../../shared/Url';
import Post from '../../shared/Post';

let status = 0;
class Validar extends Component {
    state = {
        mess: {
            class: "custom-alert-info",
            icon: "fa fa-spinner fa-spin",
            text: "Espera"
        },
        boton: {
            icon: "fa fa-check",
            text: "Validar Documento"
        },
        resultado: [],
        string: ""
    }

    componentDidMount = () => {
        let Content = this.getGET();

        if (Content === undefined){
            this.setState({
                mess: {
                    class: "custom-alert-info",
                    icon: "fa fa-exclamation-circle",
                    text: "Ingresa el código de validación"
                }
            })
        }else{
            this.setState({
                mess: {
                    class:"custom-alert-info",
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando Información, espera por favor"
                }
            }, () => {
                Post(`${Url}validarDoc`, Content, (resp) => {
                    let data = JSON.parse(resp)
                    status = data.state
                    this.setState({
                        mess: {
                            class: data.class,
                            icon: data.icon,
                            text: data.text,
                        },
                        resultado: data.resultado
                    })
                });
            })
        }
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase()
        });
    };

    getGET = () => {
        let loc = document.location.href;
        if(loc.indexOf('?') > 0){
            let getString = loc.split('?')[1];
            let GET = getString.split('&');
            let get = {};
            for(let i = 0, l = GET.length; i < l; i++){
                let tmp = GET[i].split('=');
                get[tmp[0]] = unescape(decodeURI(tmp[1]));
            }
            return get;
        }
    }

    busqueda = () => (e) => {
        if (this.state.string === "") return null

        this.setState({
            boton: {
                icon: "fa fa-spinner fa-spin",
                text: "Buscando Espera"
            },
            mess: {
                class:"custom-alert-info",
                icon: "fa fa-spinner fa-spin",
                text: "Buscando Información, espera por favor"
            }
        }, () => {
            let Content = {
                code: this.state.string
            }

            Post(`${Url}validarDoc`, Content, (resp) => {
                let data = JSON.parse(resp)
                status = data.state
                this.setState({
                    mess: {
                        class: data.class,
                        icon: data.icon,
                        text: data.text,
                    },
                    resultado: data.resultado,
                    boton: {
                        icon: "fa fa-check",
                        text: "Validar Documento"
                    },
                    string: ""
                })
            });
        })
    }

    contenido = () => {
        let { mess, boton, resultado, string } = this.state;

        const styles = {
            padding: 5, fontSize: 11
        }

        let materias = (materias) => (
            materias.map(option => (
                <tr key={option.id}>
                    <td style={styles}>{option.materia_name}</td>
                    <td align="center" style={styles}>{option.nombre}</td>
                    <td align="center" style={styles}>{option.tipoev_name}</td>
                    <td align="center" style={styles}>{option.semestre_name}</td>
                </tr>
            ))
        )

        let contentInd = (datos) => {
            switch (datos.tipo) {
                case "ADMISION":
                    return (
                        <div style={{marginBottom: 20,}}>
                            <div className="custom-alert-success"><strong>Planilla de Admisión</strong></div>
                            <div className="fondo-activate">
                                <div><span className="text-primary">Cédula del Estudiante:</span> {datos.ci}</div>
                                <div><span className="text-primary">Nombre del Estudiante:</span> {datos.estudiante}</div>

                                <div className="custom-alert-info" style={{marginTop: 5}}><strong>Detalles de la Solicitud</strong></div>
                                <Row style={{marginTop: 5, padding: 5}}>
                                    <Col md={6}>
                                        <div><span className="text-primary">Periodo Académico:</span> {datos.periodo}</div>
                                    </Col>
                                    <Col md={6}>
                                        <div><span className="text-primary">Carerra:</span> {datos.carrera}</div>
                                    </Col>
                                    <Col md={6}>
                                        <div><span className="text-primary">Fecha de la solicitud:</span> {datos.fecha}</div>
                                    </Col>
                                    <Col md={6}>
                                        <div><span className="text-primary">Fecha de la cita:</span> {datos.cita}</div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    )
                case "INSCRIPCION":
                    return (
                        <div style={{marginBottom: 20,}}>
                            <div className="custom-alert-success custom-mt-10"><strong>Planilla de Inscripción</strong></div>
                            <div className="fondo-activate">
                                <div><span className="text-primary">Cédula del Estudiante:</span> {datos.ci}</div>
                                <div><span className="text-primary">Nombre del Estudiante:</span> {datos.estudiante}</div>

                                <div className="custom-alert-info" style={{marginTop: 5}}><strong>Materias Inscritas</strong></div>
                                <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF"}}>
                                    <Table striped hover bordered style={{marginBottom: 0}}>
                                        <tbody>
                                            <tr className="custon-back-color">
                                                <td width="55%" style={styles}><strong>Materia</strong></td>
                                                <td width="15%" align="center" style={styles}><strong>Seccion</strong></td>
                                                <td width="15%" align="center" style={styles}><strong>Modalidad</strong></td>
                                                <td width="15%" align="center" style={styles}><strong>Semestre</strong></td>
                                            </tr>
                                            {materias(datos.materias)}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    )
                case "CONSTANCIA":
                    return(
                        <div style={{marginBottom: 20}}>
                            <div className="custom-alert-success custom-mt-10"><strong>Constancia de Estudios</strong></div>
                            <div className="fondo-activate">
                                <div><span className="text-primary">Cédula del Estudiante:</span> {datos.ci}</div>
                                <div><span className="text-primary">Nombre del Estudiante:</span> {datos.estudiante}</div>
                                <div><span>Fecha</span></div>
                                <div className="custom-alert-info" style={{marginTop: 5}}><strong>Materias Inscritas</strong></div>
                                <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF"}}>
                                    <Table striped hover bordered style={{marginBottom: 0}}>
                                        <tbody>
                                            <tr className="custon-back-color">
                                                <td width="55%" style={styles}><strong>Materia</strong></td>
                                                <td width="15%" align="center" style={styles}><strong>Seccion</strong></td>
                                                <td width="15%" align="center" style={styles}><strong>Modalidad</strong></td>
                                                <td width="15%" align="center" style={styles}><strong>Semestre</strong></td>
                                            </tr>
                                            {materias(datos.materias)}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    )
                case "SOLVENCIA":
                    return (
                        <div style={{marginBottom: 20}}>
                            <div className="custom-alert-info custom-mt-10"><strong>Solvencia Administrativa</strong></div>

                            <div className="fondo-activate">
                                <div><span className="text-primary">Cédula del Estudiante:</span> {datos.ci}</div>
                                <div><span className="text-primary">Nombre del Estudiante:</span> {datos.estudiante}</div>
                                <div><span className="text-primary">Fecha:</span> {datos.fecha}</div>
                                <div className="custom-mt-10 custom-alert-success" align="center">
                                    <i className="fa fa-check-circle"></i> Este estudiante se encuentra <strong>SOLVENTE</strong> para la fecha solicitada
                                </div>
                            </div>
                        </div>
                    )
                default:
                    return null
            } 
        }

        let contentValida = () => {
            if (status === 0) return null;

            return (
                <React.Fragment>
                    <div className="text-danger" style={{marginBottom: 5}}>Documentos Encontrados ({resultado.length})</div>
                    {resultado.map(option => (
                        <div key={`${option.tipo}${option.id}`}>{contentInd(option)}</div>
                    ))}
                </React.Fragment>
                
            )
        }

        return(
            <div style={{maxHeight: "50vh", overflowY: "auto", overflowX: "hidden"}}>
                <div className={mess.class} style={{padding: 5}}><i className={mess.icon}></i> {mess.text}</div>
                <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                    <Row>
                        <Col md={12}>
                            <input className="form-control" value={string} onChange={this.cambiaValor("string")} maxLength={10}/>
                            <div className="text-primary" style={{fontSize:10}}>Código de Validación</div>
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col md={12} align="right" className="custom-mt-10">
                        <button className="btn btn-primary" onClick={this.busqueda()} style={{borderWidth: 1}}><i className={boton.icon}></i> {boton.text}</button>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        {contentValida()}
                    </Col>
                </Row>
            </div>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={3} className="fuente-monserrat">
                <strong>Paso 1</strong>
            </Col>
            <Col md={9} align="justify" className="fuente-monserrat">
                Introduce el código de validación del documento (En caso de haber escaneado el código Qr omite este paso)
            </Col>
            <Col md={3} className="fuente-monserrat custom-mt-10">
                <strong>Paso 2</strong>
            </Col>
            <Col md={9} align="justify" className="fuente-monserrat custom-mt-10">
                Presiona el botón <button className="btn btn-primary btn-sm" style={{borderWidth: 1}}><i className="fa fa-check"></i> Validar Documento</button> para ver el (los) resultado(s). En caso de haber escaneado el código Qr omite este paso
            </Col>
            <Col md={3} className="fuente-monserrat custom-mt-10">
                <strong>Paso 3</strong>
            </Col>
            <Col md={9} align="justify" className="fuente-monserrat custom-mt-10">
                Chequea toda la información obtenida del resultado (Datos del estudiante, detalles del documento, etc.)
            </Col>
            <Col md={12} align="justify" className="fuente-monserrat custom-mt-10">
                <strong style={{fontSize: 10}}>Importante: En caso de no obtener resultados, significa que el documento no es válido para la institución</strong>
            </Col>
        </Row>
    )

    render() { 
        return (
            <React.Fragment>
                <div className="wrapper2">
                    <div className="wave one"></div>
                    <div className="wave dos"></div>
                    <div className="wave tres"></div>
                </div>
                <HeaderHome />
                <div className="login-content" style={{position:"fixed", }}>
                    <Row>
                        <Col md={1}></Col>
                        <Col md={10}>
                            <Col md={8}>
                                <div style={{/* boxShadow: "1px 1px 2px #000",  */borderRadius: "4px 4px",}}>
                                <CustomCard
                                    title="Validación de Documentos"
                                    color="#a80012"
                                    content={this.contenido()}
                                />
                                </div>
                            </Col>
                            <Col md={4}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}} className="fuente-monserrat"><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}} className="fuente-monserrat">Validación de Documentos</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </Col>
                        </Col>
                        <Col md={1}></Col>
                    </Row>
                </div>
            </React.Fragment>
        );
    }
}
 
export default Validar;


// WEBPACK FOOTER //
// ./src/site/Views/Validar.jsx